<template>
    <Card>
        <template #content>
            <div class="text-xs font-semibold uppercase text-gray-600">
                {{ title }}
            </div>
            <div class="flex items-center justify-start gap-2">
                <div class="text-2xl font-bold">
                    {{ value }}
                </div>
            </div>
        </template>
    </Card>
</template>

<script setup lang="ts">
    import Card from '@/Shared/Component/Card.vue'

    const props = defineProps({
        title: {
            type: String,
            required: true,
        },
        value: {
            type: Number,
            required: true,
        },
    })
</script>
